import requiredHoursModal from './required-hours/required-hours.component';
import submitTimesheeModal from './submit-timesheet/submit-timesheet.component';
import taskSelectionModal from './task-selection/task-selection.component';
import timeEntryUpdatesModal from './time-entry-updates/time-entry-updates.component';


export default angular.module('app.pages.timesheet.modals', [

  ]);



// WEBPACK FOOTER //
// ./client/pages/timesheet/modals/modals.js